import React, { useEffect, useState } from 'react';  
import Navbar from '../components/Navbar';  
import Footer from '../components/Footer';  
import { Link, useNavigate } from 'react-router-dom';  
import Spinner from '../components/Spinner';
import { useAuth } from '../context/AuthContext';
import { batchAPI } from '../services/api';
import '../styles/PremiumPage.css';  
import EnglishVocabImg from '../assets/EnglishVocab.jpeg';

export default function PremiumPage() {  
  const [batches, setBatches] = useState([]);  
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null);
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true); 
    setError(null);
    try {
      const response = await batchAPI.getAllBatches();
      if (response.data.success) {
        setBatches(response.data.batches);
      } else {
        setError('बॅचेस लोड करण्यात अयशस्वी');
      }
    } catch (error) {
      console.error('Error fetching batches:', error);
      setError('प्रीमियम बॅचेस लोड करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.');
    } finally {
      setLoading(false);
    }
  };

  const handleBatchClick = (batchId) => {
    navigate(`/premium-batch/${batchId}`);
  };

  const handleCreateBatch = () => {
    navigate('/create-new-batch');
  };

  return (  
    <>  
      <Navbar />  
      <div className="container-fluid premium-page">  
        <div className="row">  
          <div className="col-md-12 text-center">  
            <br />
            <h1 className="premium-heading">🎓 स्पर्धावेब प्रीमियम अभ्यासक्रमांमध्ये आपले स्वागत आहे</h1>  
            <p className="premium-description">  
              तुमच्या परीक्षेत उत्कृष्ट कामगिरी करण्यासाठी विशेष प्रश्नसंच आणि बॅचेस अनलॉक करा.
            </p>

            {/* Admin Create Batch Button */}
            {user?.role === 'admin' && (
              <button 
                onClick={handleCreateBatch} 
                className="btn btn-warning btn-lg my-3"
                style={{ fontWeight: 'bold' }}
              >
                ➕ नवीन बॅच तयार करा
              </button>
            )}
          </div>  
        </div>

        {/* Error Message */}
        {error && (
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-danger text-center" role="alert">
                {error}
              </div>
            </div>
          </div>
        )}

        <div className="row">  
          <div className="col-md-12 quizzes-container">  
            {loading ? (  
              <Spinner />
            ) : batches.length === 0 ? (
              <div className="text-center my-5">
                <h3>अद्याप कोणतेही प्रीमियम बॅचेस उपलब्ध नाहीत</h3>
                <p className="text-muted">नवीन अभ्यासक्रमांसाठी नंतर तपासा!</p>
              </div>
            ) : (  
              <div className="container my-3 flex-grow-1">  
                <div className="row">  
                  {batches.map((batch) => (  
                    <React.Fragment key={batch._id}>  
                      <div className="col-md-4">  
                        <div className="my-3">  
                          <div className="card premium-batch-card">  
                            <div className="batch-image-container">
                              <img 
                                src={batch.imageUrl || EnglishVocabImg} 
                                className="card-img-top" 
                                alt={batch.name}
                              />
                              {batch.price > 0 && (
                                <div className="batch-price-badge">
                                  ₹{batch.price}
                                </div>
                              )}
                            </div>
                            <div className="card-body">  
                              <h5 className="card-title">{batch.name}</h5>  
                              <p className="card-text">
                                <strong>📚 विषय:</strong> {batch.subject}
                              </p>
                              <p className="card-text batch-description">
                                {batch.description 
                                  ? (batch.description.length > 100 
                                    ? batch.description.substring(0, 100) + '...' 
                                    : batch.description)
                                  : 'वर्णन उपलब्ध नाही'}
                              </p>
                              <div className="d-flex gap-2">
                                <button 
                                  className="btn btn-primary flex-grow-1" 
                                  onClick={() => handleBatchClick(batch._id)}
                                  style={{ fontSize: '1rem', padding: '10px' }}
                                >
                                  तपशील पहा
                                </button>
                                {/* Quick access for enrolled users/admin */}
                                {(user?.role === 'admin') && (
                                  <Link 
                                    className="btn btn-dark" 
                                    to={`/premium-tests/${batch._id}`}
                                    style={{ fontSize: '1rem', padding: '10px' }}
                                  >
                                    प्रश्नसंच →
                                  </Link>
                                )}
                              </div>
                              {/* Admin Actions */}
                              {user?.role === 'admin' && (
                                <div className="mt-2 d-flex gap-2">
                                  <Link 
                                    className="btn btn-sm btn-warning flex-grow-1" 
                                    to={`/update-batch/${batch._id}`}
                                  >
                                    ✏️ संपादित करा
                                  </Link>
                                  <Link 
                                    className="btn btn-sm btn-info flex-grow-1" 
                                    to={`/manage-batch/${batch._id}`}
                                  >
                                    👥 व्यवस्थापित करा
                                  </Link>
                                </div>
                              )}
                            </div>  
                          </div>  
                        </div>  
                      </div>  
                    </React.Fragment>  
                  ))}  
                </div>  
              </div>  
            )}  
          </div>  
        </div>

        {/* Info Section */}
        <div className="row my-5">
          <div className="col-md-12">
            <div className="premium-info-section">
              <h3>प्रीमियम बॅचेस का निवडावे?</h3>
              <div className="row mt-4">
                <div className="col-md-3 text-center">
                  <div className="info-card">
                    <div className="info-icon">📝</div>
                    <h5>विशेष सामग्री</h5>
                    <p>प्रीमियम प्रश्नसंच आणि अभ्यास साहित्य उपलब्ध</p>
                  </div>
                </div>
                <div className="col-md-3 text-center">
                  <div className="info-card">
                    <div className="info-icon">📊</div>
                    <h5>प्रगती ट्रॅक करा</h5>
                    <p>तुमची कामगिरी आणि सुधारणा पहा</p>
                  </div>
                </div>
                <div className="col-md-3 text-center">
                  <div className="info-card">
                    <div className="info-icon">🎯</div>
                    <h5>तज्ञांनी तयार केलेले</h5>
                    <p>विषय तज्ञांनी डिझाइन केलेली सामग्री</p>
                  </div>
                </div>
                <div className="col-md-3 text-center">
                  <div className="info-card">
                    <div className="info-icon">⏰</div>
                    <h5>आजीवन प्रवेश</h5>
                    <p>तुमच्या गतीने, कधीही शिका</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
      <Footer />  
    </>  
  );  
}